document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', e => {
    const swatchInput = e.target.closest('.boost-sd__product-swatch-option input');
    if (!swatchInput) return;

    const productCard = swatchInput.closest('[data-product-id]');
    if (!productCard) return;

    const productLink = productCard.querySelector('.boost-sd__product-link');
    if (!productLink) return;
    const productHandle = productLink.href.split('/products/')[1].split('?')[0];

    const productData = productCard.dataset.product ? JSON.parse(productCard.dataset.product) : null;

    if (!productData || !productData.variants) {
      console.log('No variants found');
      return;
    }

    let variants;
    try {
      variants = JSON.parse(productData.variants);
    } catch (e) {
      console.error('Failed to parse variants', e);
      variants = [];
    }

    const selectedOption = swatchInput.value?.trim() || '';

    const matchingVariant = variants.find(
      variant => variant?.title?.trim().includes(selectedOption)
    );

    // No variant for this swatch: keep the current link instead of throwing.
    if (!matchingVariant) return;

    // Only swap the variant in the query string, so the language prefix (/en) and
    // the rest of the existing product path are kept.
    const url = new URL(productLink.getAttribute('href') || `/products/${productHandle}`, window.location.origin);
    url.searchParams.set('variant', matchingVariant.id);
    productLink.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  });
});
